import { render } from "./ImplantsLoseTeeth.vue?vue&type=template&id=977b5516"
import script from "./ImplantsLoseTeeth.vue?vue&type=script&lang=js"
export * from "./ImplantsLoseTeeth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__